import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { BudgetNotEditable } from './budget-not-editable';
import { CampaignInlineBudgetEditor } from './inline-budget-editor';
import { CampaignSharedBudgetEditor } from './shared-budget-editor';

export const CampaignBudgetEditor = ({
  experimentId, budget, campaignType, campaignId, onSave, onCancel, updateInlineBudget, updateSharedBudget, hasBudgetLandscape, summaryBarActivityLogger, scope, siteMap, i18n, permissions, campaignSubType,
}) => {
  if (experimentId > 0) {
    return (<BudgetNotEditable />);
  }

  if (budget && budget.Id) {
    const data = _.pick(budget, 'Amount');

    return (<CampaignSharedBudgetEditor
      data={data}
      budgetId={budget.Id}
      campaignId={campaignId}
      onSave={onSave}
      onCancel={onCancel}
      updateSharedBudget={updateSharedBudget}
      hasBudgetLandscape={hasBudgetLandscape}
      summaryBarActivityLogger={summaryBarActivityLogger}
      scope={scope}
      siteMap={siteMap}
      i18n={i18n}
      permissions={permissions}
    />);
  }

  if (budget && budget.Amount) {
    const data = _.pick(budget, 'Amount', 'Type');

    return (<CampaignInlineBudgetEditor
      data={data}
      budget={budget}
      campaignType={campaignType}
      campaignSubType={campaignSubType}
      campaignId={campaignId}
      onSave={onSave}
      onCancel={onCancel}
      updateInlineBudget={updateInlineBudget}
      hasBudgetLandscape={hasBudgetLandscape}
      summaryBarActivityLogger={summaryBarActivityLogger}
      scope={scope}
      i18n={i18n}
      permissions={permissions}
    />);
  }
  return null;
};

CampaignBudgetEditor.propTypes = {
  campaignType: PropTypes.number.isRequired,
  campaignId: PropTypes.number.isRequired,
  experimentId: PropTypes.number,
  budget: PropTypes.shape({}),
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  updateSharedBudget: PropTypes.func,
  updateInlineBudget: PropTypes.func,
  hasBudgetLandscape: PropTypes.bool.isRequired,
  summaryBarActivityLogger: PropTypes.shape({
    summaryBarBudgetActivity: PropTypes.any,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  campaignSubType: PropTypes.string.isRequired,
};

CampaignBudgetEditor.defaultProps = {
  experimentId: null,
  budget: null,
  onSave: _.noop,
  onCancel: _.noop,
  updateInlineBudget: _.noop,
  updateSharedBudget: _.noop,
};
